import axios from "axios";
import { ErrorObject } from "./types/errors";

export const reportError = async (
  error: Error,
  context: string
): Promise<void> => {
  const errorObj: ErrorObject = {
    service: "fun-learning-front",
    context,
    code: error.name,
    message: error.message,
    stack: error.stack,
  };

  try {
    await axios.post(
      "https://chamstudyland.com/api/errors/report_error.php",
      errorObj,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  } catch (err) {
    console.error("Failed to report error:", err);
  }
};
